<template>
  <va-app
    bg-color="#FFFFFF"
    page-bg-color="#FFFFFF"
    desktop-margin="0"
    desktop-minimum-width="0"
    :desktop-sidebar-width="desktopSidebarWidth"
    desktop-topbar-height="70"
    :mobile-sidebar-width="0"
    mobile-minibar-width="0"
    mobile-topbar-height="70"
    :rtl="false"
    :reverse="false"
    :split="false"
    :sidebar-priority="false"
    :minibar-priority="false"
    :topbar-priority="false"
    :topbar-padded="false"
  >
    <NewTopbar />
    <!-- <Topbar /> -->
    <Sidebar />
    <va-page class="static" size="lg">
      <transition name="slide-fadein-up" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>
    </va-page>
  </va-app>
</template>

<script>
// const Topbar = () => import('@/components/App/Menus/Topbar')
const NewTopbar = () => import('@/components/App/Menus/Topbar/New')
const Sidebar = () => import('@/components/App/Menus/Sidebar')
export default {
  data() {
    return {
    }
  },
  watch: {
    '$route'(to, from) {
      // console.log(to)
    },
  },
  methods: {
    setViewPort() {
      const { innerWidth: width } = window
      const isMobile = width < 768
      const isTablet = width > 768 && width < 992
      this.$store.commit('SET_STATE', { isMobileView: isMobile, isTabletView: isTablet })
    },
  },
  mounted() {
    // console.log('masu')
  },
  created() {
    window.addEventListener('resize', () => {
      this.setViewPort()
    })
    // console.log('masuk')
    // this.VaModal.confirm({
    //   title: 'Hello!',
    //   message: `This modal exists to show how methods
    //   can be applied to Minibar items.`,
    //   type: 'info',
    // })
  },
  computed: {
    desktopSidebarWidth() {
      if (!this.sidebarIsExpanded) return 108
      return 240
    },
    sidebarIsExpanded() { return this.$store.state.sidebarIsExpanded },
  },
  components: {
    // Topbar,
    Sidebar,
    NewTopbar,
  },
}
</script>

<style lang="scss">
.va-page-container {
  height: 90vh;
  .va-page-container-lg {
    @apply pt-8;
    @media (min-width: 456px) {
      padding: 25px 28px;
    }

    > div:last-child {
      height: 100px !important;
      @media (min-width: 456px) {
        height: 20px !important;
      }
    }
  }
}
</style>
